import React from 'react';
import { Grid, Typography, TextField } from '@mui/material';
import { TutorProfile } from '../../services/interfaces';

interface ProfileBioProps {
    profile: TutorProfile;
    isEditing: boolean;
    onChange: (field: keyof TutorProfile, value: any) => void;
}

const ProfileBio: React.FC<ProfileBioProps> = ({ profile, isEditing, onChange }) => {
    return (
        <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
                About Me
            </Typography>
            {isEditing ? (
                <TextField
                    multiline
                    rows={4}
                    fullWidth
                    value={profile.bio || ''}
                    onChange={(e) => onChange('bio', e.target.value)}
                    placeholder="Tell students about yourself..."
                />
            ) : (
                <Typography variant="body1" color="text.secondary" sx={{ whiteSpace: 'pre-line' }}>
                    {profile.bio || 'No bio available.'}
                </Typography>
            )}
        </Grid>
    );
};

export default ProfileBio;
